import asyncComponent from '../common/utils/async-component';

/* istanbul ignore next */
const Auth = asyncComponent(async () => import('./components/auth'));

/* istanbul ignore next */
const ClaimProject = asyncComponent(async () => import('./components/claim-project'));

/* istanbul ignore next */
const CheckEmail = asyncComponent(async () => import('./components/check-email'));

export default {
  '/netlify-addon': {
    '/auth': {
      components: { main: Auth }
    },
    '/claim': {
      components: { main: ClaimProject }
    },
    '/check-email': {
      components: { main: CheckEmail }
    }
  }
};
